import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/x-dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-dad21636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%","object-fit":"cover","position":"absolute"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = {
  key: 0,
  class: "spinner"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "title-text" }
const _hoisted_9 = { class: "body-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "login-actions" }
const _hoisted_12 = { class: "back-to-login" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-left" }, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "title-text" }
const _hoisted_16 = { class: "body-text" }
const _hoisted_17 = { class: "login-actions" }
const _hoisted_18 = { class: "back-to-login" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-left" }, null, -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "title-text" }
const _hoisted_23 = { class: "body-text" }
const _hoisted_24 = { class: "login-actions" }
const _hoisted_25 = { class: "back-to-login" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-left" }, null, -1))
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "title-text" }
const _hoisted_29 = { class: "body-text" }
const _hoisted_30 = { class: "request-actions" }
const _hoisted_31 = { class: "login-btn" }
const _hoisted_32 = { class: "login-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_imdex_spinner, {
              size: "5",
              width: "50"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isAccessRequested)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.isActive === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`requestAccess.accessDenied`)), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t(`requestAccess.requestDeniedExpl`)), 1),
                            _hoisted_10,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(`requestAccess.seeAdmins`)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoutAndBack && _ctx.logoutAndBack(...args)))
                              }, [
                                _hoisted_13,
                                _createTextVNode("   " + _toDisplayString(_ctx.$t(`requestAccess.backToLogin`)), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(`requestAccess.accessRequested`)), 1),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`requestAccess.accessRequestedExpl`)), 1),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logoutAndBack && _ctx.logoutAndBack(...args)))
                              }, [
                                _hoisted_19,
                                _createTextVNode("   " + _toDisplayString(_ctx.$t(`requestAccess.backToLogin`)), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_ctx.isActive === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t(`requestAccess.accountDeactivated`)), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`requestAccess.noAccessExpl`)), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logoutAndBack && _ctx.logoutAndBack(...args)))
                              }, [
                                _hoisted_26,
                                _createTextVNode("   " + _toDisplayString(_ctx.$t(`requestAccess.backToLogin`)), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t(`requestAccess.noAccess`)), 1),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`requestAccess.howToRequest`)), 1),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_imdex_btn, {
                                onClick: _withModifiers(_ctx.logoutAndBack, ["prevent"]),
                                text: "",
                                small: "",
                                secondary: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`requestAccess.noSSO`)), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_imdex_btn, {
                                onClick: _withModifiers(_ctx.requestAccess, ["prevent"]),
                                small: "",
                                secondary: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`requestAccess.requestAccess`)), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]))
                ]))
          ]))
    ])
  ]))
}